export const validatePasswordPolicy = (password) => {
  if (!password || password.length < 12) {
    return 'Password must be at least 12 characters long';
  }
  const categories = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];
  const matched = categories.filter((re) => re.test(password)).length;
  if (matched < 3) {
    return 'Password must include at least 3 of: uppercase, lowercase, number, special character';
  }
  return null;
};
